import { render } from "./deals-status.vue?vue&type=template&id=49cff0ca"
import script from "./deals-status.vue?vue&type=script&lang=js"
export * from "./deals-status.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__